module.exports = __webpack_public_path__ + "media/images/jamicons/envelope-f-bf5e7f71996e472a6888ce733594b8a1.svg";